export const LAYOUT_ENDPOINT: string=`core/layout`;
